import { Select } from "chakra-react-select";
import { useEffect, useState } from "react";
import SystemApi from "../../../../services/systemApi";

export default function TipoServicoSelect({ idSelect, setIdSelect }: any) {
    const [itemList, setItemList] = useState(Array<{
        id: number;
        servico: string;
    }>);
    const [search, setSearch] = useState("");

    async function getTipoServicoList() {
        try {
            const response = await SystemApi.getTipoServico();
            console.log("respons", response)
            setItemList(response);
        } catch (error) {
            console.log("error", error);
        }
    }

    useEffect(() => {
        getTipoServicoList();
    }, [search]);

    const clientOptions =
        itemList &&
        itemList.map((client) => {
            return {
                key: client.id,
                value: client.id,
                label: client.servico,
            };
        });

    function onChangeInput(item: any) {
        // console.log("evento do input", item)
        setSearch(item);
    }

    function onChangeClientFilter(e: any) {
        setIdSelect(e.value);
    }

    // useEffect(() => {
    //     if(idSelect !== 0 && idSelect !== null){
            
    //     }
    // },[idSelect]);

    return (
        <>
            <Select
                name="colors"
                // isMulti
                options={clientOptions}
                // value={cliente}
                placeholder="Filtrar por tipo serviço"
                closeMenuOnSelect={true}
                size="md"
                onChange={(e: any) => {
                    onChangeClientFilter(e);
                }}
                onInputChange={(e: any) => {
                    onChangeInput(e);
                }}
            ></Select>
        </>
    );
}
